var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "channel-picker" },
    [
      _c(
        "a-popover",
        {
          attrs: {
            placement: "rightTop",
            overlayClassName: "channel-picker-popover",
            visible: _vm.visible,
          },
          scopedSlots: _vm._u([
            {
              key: "content",
              fn: function () {
                return [
                  _c("div", { staticClass: "picker-content" }, [
                    _c("div", { staticClass: "header" }, [
                      _vm._v("Channel Filter"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "search-wrapper" },
                      [
                        _c("a-input-search", {
                          attrs: { placeholder: "search channel" },
                          model: {
                            value: _vm.search,
                            callback: function ($$v) {
                              _vm.search = $$v
                            },
                            expression: "search",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "btnGroup" },
                      [
                        _c(
                          "SupsisButton",
                          {
                            attrs: {
                              classNames:
                                _vm.mode === "active"
                                  ? "btnGroupItem selected"
                                  : "btnGroupItem ",
                              primary: _vm.mode === "active",
                              ghost: _vm.mode !== "active",
                              small: "",
                            },
                            on: {
                              click: function () {
                                return _vm.changeMode("active")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Active Channels\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "SupsisButton",
                          {
                            attrs: {
                              classNames:
                                _vm.mode === "deleted"
                                  ? "btnGroupItem selected"
                                  : "btnGroupItem ",
                              primary: _vm.mode === "deleted",
                              ghost: _vm.mode !== "deleted",
                              small: "",
                            },
                            on: {
                              click: function () {
                                return _vm.changeMode("deleted")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Deleted Channels\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "groups" },
                      [
                        _vm.getFilteredChannels("whatsapp-qr").length
                          ? _c("div", { staticClass: "group-title" }, [
                              _vm._v(
                                "\n                        Whatsapp V1 Channels\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(
                          _vm.getFilteredChannels("whatsapp-qr"),
                          function (channel) {
                            return _c(
                              "div",
                              {
                                staticClass: "list-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.change(channel._id)
                                  },
                                },
                              },
                              [_c("span", [_vm._v(_vm._s(channel.name))])]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _vm.getFilteredChannels("whatsapp-v2").length
                          ? _c("div", { staticClass: "group-title" }, [
                              _vm._v(
                                "\n                        Whatsapp V2 Channels\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(
                          _vm.getFilteredChannels("whatsapp-v2"),
                          function (channel) {
                            return _c(
                              "div",
                              {
                                staticClass: "list-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.change(channel._id)
                                  },
                                },
                              },
                              [_c("span", [_vm._v(_vm._s(channel.name))])]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _vm.getFilteredChannels("whatsapp-business-api").length
                          ? _c("div", { staticClass: "group-title" }, [
                              _vm._v(
                                "\n                        Whatsapp Business API\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(
                          _vm.getFilteredChannels("whatsapp-business-api"),
                          function (channel) {
                            return _c(
                              "div",
                              {
                                staticClass: "list-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.change(channel._id)
                                  },
                                },
                              },
                              [_c("span", [_vm._v(_vm._s(channel.name))])]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _vm.getFilteredChannels("instagram").length
                          ? _c("div", { staticClass: "group-title" }, [
                              _vm._v("Instagram"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(
                          _vm.getFilteredChannels("instagram"),
                          function (channel) {
                            return _c(
                              "div",
                              {
                                staticClass: "list-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.change(channel._id)
                                  },
                                },
                              },
                              [_c("span", [_vm._v(_vm._s(channel.name))])]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _vm.getFilteredChannels("messenger").length
                          ? _c("div", { staticClass: "group-title" }, [
                              _vm._v("Messenger"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(
                          _vm.getFilteredChannels("messenger"),
                          function (channel) {
                            return _c(
                              "div",
                              {
                                staticClass: "list-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.change(channel._id)
                                  },
                                },
                              },
                              [_c("span", [_vm._v(_vm._s(channel.name))])]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { ghost: "" },
              on: {
                click: function () {
                  return (_vm.visible = !_vm.visible)
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("filter_list"),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.getSelectedChannelName()))]),
              _vm._v(" "),
              !_vm.visible
                ? _c("i", { staticClass: "material-icons" }, [
                    _vm._v("arrow_drop_down"),
                  ])
                : _c("i", { staticClass: "material-icons" }, [
                    _vm._v("arrow_drop_up"),
                  ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }